export class MsalErrorConstants {
      public static VIEWS_LOGIN_IAM_ERROR_SERVER = 'views.login.iam.error.server';
      public static VIEWS_LOGIN_IAM_ERROR_PROFILE = 'views.login.iam.error.profil';
      public static VIEWS_LOGIN_IAM_ERROR_CONTRY = 'views.login.iam.error.contry';
  }
